import React from "react";

export function ContactInfo() {
    return (
        <div className="d-flex flex-column align-items-center">
            <h2 className="fs-1 mb-3 text-uppercase fw-bold">Onde nos encontrar</h2>
            <p className="mb-5">47 Baker Street, London LD1 0ND</p>
            <h3>Horário de Funcionamento</h3>
            <p className="m-0">Seg - Sex: 09:00 - 17:00</p>
            <p>Sab - Dom: 10:00 - 15:00</p>
        </div>
    )
}